import * as React from 'react';
import './index.scss';
import openLink from 'libs/open-link';
import { sendEvent } from 'libs/event';

interface ICategory {
    name: string;
    id: number;
}

export interface ICategories {
    // eslint-disable-next-line camelcase
    card_type: 'category';
    categories: ICategory[];
    // eslint-disable-next-line camelcase
    feed_index: number;
    page: number;
    // eslint-disable-next-line camelcase
    req_id: string;
}

export interface ICategoryProps {
    categories: ICategories;
    beforeClickCategory?: (url: string) => string;
    beforeReportEvent?: (params: {
        [key: string]: string | number;
    }) => { [key: string]: string | number };
}

export function Category(props: ICategoryProps) {
    const clickCategoryEvent = (id: number) => {
        const extra = { activity_id: id };
        if (props.beforeReportEvent) {
            props.beforeReportEvent(extra);
        }
        sendEvent('click_category_tag', extra);
    };

    const clickCategory = (cat: ICategory) => {
        clickCategoryEvent(cat.id);
        const url = '/views/channel/categorylist?cids=' + cat.id;
        openLink(url, { title: cat.name });
    };

    return (
        <div className="category">
            <h3 className="category__name">
                <span className="category__name-text">细选</span>
            </h3>
            <div className="category__list">
                {props.categories.categories.map((item) => {
                    return (
                        <span
                            onClick={() => clickCategory(item)}
                            key={item.id}
                            className="category__list--detail"
                        >
                            {item.name}
                        </span>
                    );
                })}
            </div>
        </div>
    );
}
